export const environment = {
  production: true,
  webDomain: 'app.katcha.preprod-s3.cawita.com',
  apiUrl: 'https://katcha.preprod-s3.cawita.com/api/',
  socketUrl: 'https://katcha.preprod-s3.cawita.com/',
  customImageUrl: 'https://katcha.preprod-s3.cawita.com/custom-images/',
  assetUrl: 'https://katcha.preprod-s3.cawita.com/',
  protectedAssetUrl: '',
  publicAssetPathUrl: 'public-folder/',
  translateFilePath: '/assets/i18n/',
  captchaKey: '6LeyRZQlAAAAAH14czmymhxwwNrFwQte13IjkvbR'
};
